import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DialogService } from 'primeng/dynamicdialog';
import { defaultListPaginationParameters } from '../../../data-access';
import { ActionConfigFactory, ActionTypeEnum, IActionConfig } from '../../../ui';
import { CountriesApiClientProvider, ICountriesApiClient } from '../clients';
import { ICountriesResponse } from '../dtos';
import { LocationManagementPermissions } from '../../common/permissions';
import { CreateUpdateCountryComponent } from '../../../../../trash/location-management';
import { SoftDeletableAuditableTranslatableLookupsComponent } from "../../../lookups/components/soft-deletable-auditable-translatable-lookups/soft-deletable-auditable-translatable-lookups.component";

@Component({
  selector: 'app-countries',
  standalone: true,
  providers: [],
  imports: [CommonModule, SoftDeletableAuditableTranslatableLookupsComponent],
  templateUrl: './countries.component.html',
  styleUrls: ['./countries.component.scss']
})
export class CountriesComponent {
  client: ICountriesApiClient = inject(CountriesApiClientProvider).getClient();
  dialogService = inject(DialogService);
  translate = inject(TranslateService);
  router = inject(Router);
  defualtPaginationParameters = defaultListPaginationParameters;

  supportedActions: IActionConfig<ICountriesResponse>[] = [
    ActionConfigFactory.createDialog(this.dialogService, {
      type: ActionTypeEnum.VIEW,
      componentType: CreateUpdateCountryComponent,
      headerResolver: (x) => `${this.translate.instant('LOCATION_MANAGEMENT.COUNTRY')} '${x!.englishName}'`,
      permission: LocationManagementPermissions.Countries.Read
    }),
    // {
    //   type: ActionTypeEnum.CREATE,
    //   label: `${this.translate.instant('GENERAL.CREATE')} ${this.translate.instant('LOCATION_MANAGEMENT.NEW_COUNTRY')}`,
    //   handlerType: ActionTypeHandlerEnum.DIALOG,
    //   handlerConfig: {
    //     componentType: CreateUpdateCountryComponent,
    //     configResolver: (item?: ICountriesResponse) => ({
    //       data: {
    //         item: item,
    //         visible: true
    //       },
    //       header: `${this.translate.instant('GENERAL.CREATE')} ${this.translate.instant('LOCATION_MANAGEMENT.COUNTRY')}`
    //     }),
    //     service: this.dialogService
    //   },
    //   permission: LocationManagementPermissions.Countries.Create
    // },
    // {
    //   type: ActionTypeEnum.UPDATE,
    //   handlerType: ActionTypeHandlerEnum.DIALOG,
    //   handlerConfig: {
    //     componentType: CreateUpdateCountryComponent,
    //     configResolver: (item?: ICountriesResponse) => ({
    //       data: {
    //         item: item,
    //         visible: true
    //       },
    //       header: `${this.translate.instant('LOCATION_MANAGEMENT.COUNTRY')} '${item!.englishName}'`
    //     }),
    //     service: this.dialogService
    //   },
    //   permission: LocationManagementPermissions.Countries.Update
    // }
  ];
}
